var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.996,
    height: 17.878,
    viewBox: "0 0 18.996 17.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M0,6.556c.016-.65.055-2.241.084-3.179a3.264,3.264,0,0,1,.74-2.37C1.466.4,2.214.255,4,.151A99.976,99.976,0,0,1,17.633.338a1.6,1.6,0,0,1,.865.23c.233.171.263.362.325,1.36.036.571.108,2.1.146,2.934-1.821-.1-4.912-.269-7.6-.3s-5.117.017-5.4.056a1.275,1.275,0,0,0-.938.5L19,7.884v2.173Z",
    transform: "translate(0 0)",
    fill: "#e7e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M0,14l19,3.63c-.013.53-.055,2.211-.087,3.175a3.071,3.071,0,0,1-.74,2.283c-.641.584-1.389.724-3.176.824A103.828,103.828,0,0,1,1.362,23.73,1.639,1.639,0,0,1,.5,23.509C.263,23.344.234,23.16.172,22.2.13,21.556.039,19.656.01,19.028c2.449.17,6.212.294,9.279.294.77,0,2.772.025,3.3.025a1.448,1.448,0,0,0,1.261-.572L0,16.35Z",
    transform: "translate(0 -6.178)",
    fill: "#e7e7e7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.1ccbf6109475e02fc20e68f22a8d5a34.svg";
export { ForwardRef as ReactComponent };